import { useOrganization } from 'hooks';
import { useMemo } from 'react';
import {
  getTimeOffTypeDefinition,
  TIMEOFF_TYPE_IDENTIFIERS,
  type TimeOffTypeIdentifier,
} from 'utils/constants/timeOffType';
import type { IOrganizationTimeOffSettingsDefinition, IOrganizationTimeOffSettings } from 'utils/organization/timeOffSettings/timeOffSettingsTypes';
import { parseOrganizationTimeOffSettings } from 'utils/organization/timeOffSettings/timeOffSettingsUtils';

export function useOrganizationTimeOffSettings(): IOrganizationTimeOffSettings {
  const { timeOffSettings: timeOffSettingsJson } = useOrganization();

  const timeOffSettings = useMemo(
    () => parseOrganizationTimeOffSettings(timeOffSettingsJson ?? ''),
    [timeOffSettingsJson]
  );

  return timeOffSettings;
}

export function useGetTimeOffTypeDefinition() {
  const timeOffSettings = useOrganizationTimeOffSettings();

  return (type: TimeOffTypeIdentifier) => getTimeOffTypeDefinition(type, timeOffSettings);
}

export function useTimeOffTypeDefinitions(): Record<TimeOffTypeIdentifier, IOrganizationTimeOffSettingsDefinition> {
  const getTimeOffTypeDefinition = useGetTimeOffTypeDefinition();

  return TIMEOFF_TYPE_IDENTIFIERS.reduce(
    (acc, type) => {
      acc[type] = getTimeOffTypeDefinition(type);
      return acc;
    },
    {} as Record<TimeOffTypeIdentifier, IOrganizationTimeOffSettingsDefinition>
  );
}
